import { render, staticRenderFns } from "./StockItem.vue?vue&type=template&id=7514d274"
import script from "./StockItem.vue?vue&type=script&lang=js"
export * from "./StockItem.vue?vue&type=script&lang=js"
import style0 from "./StockItem.vue?vue&type=style&index=0&id=7514d274&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports